/* eslint-disable */
import store from '@/store'
import i18n from '@/lang'
export default function () {
  return {
    // 过滤对象中的属性
    getFilterObj: function (obj, keyArray) {
      const arr = Object.keys(obj).filter(item => keyArray.includes(item))
      const result = {}
      for (const item of arr) {
        result[item] = obj[item]
      }
      return result
    }.bind(this),
    isEmpty: function (s) {
      return (s == null || s.length == 0);
    }.bind(this),

    isInteger: function (s) {
      return (this.$_format.REGEXP_INTEGER.test(s))
    }.bind(this),
    /**
     * 判断输入变量是否是浮点数（即小数点后有数字）
     * @param {string} s 要检查的变量值
     * @returns {boolean} 是否为浮点数
     */
    isFloat: function (s) {
      return (this.$_format.REGEXP_FLOAT.test(s));
    }.bind(this),

    /**
     * 检查字符串是否为正数（整数或浮点数)
     * @param {string} s 字符串
     * @returns {boolean} 是否为正数（整数或浮点数)
     */
    isDecimal: function (s) {
      return (this.$_format.REGEXP_DECIMAL.test(s));
    }.bind(this),
    /**
     * 检查字符串是否为合法的金额
     * @param {string} s 字符串
     * @returns {boolean} 是否为合法金额
     */
    isMoney: function (s) {
      return (this.$_format.REGEXP_MONEY.test(s));
    }.bind(this),

    /**
     * 检查字符串是否为合法的固定电话号码
     * @param {string} s 字符串
     * @returns {boolean} 是否为合法固定电话号码
     */
    isPhone: function (s) {
      return (this.$_format.REGEXP_PHONE.test(s));
    }.bind(this),
    /**
     * 检查字符串是否为合法的手机号码
     * @param {string} s 字符串
     * @returns {boolean} 是否为合法手机号码
     */
    isMobile: function (s) {
      return (this.$_format.REGEXP_MOBILE.test(s));
    }.bind(this),
    /**
     * 检查字符串是否为合法联系电话
     * @param {string} s 字符串
     * @returns {boolean} 是否为合法联系电话
     */
    isConnection: function (s) {
      return (this.$_format.REGEXP_CONNECTION.test(s));
    }.bind(this),
    /**
     * 检查字符串是否全部为中文
     * @param {string} s 字符串
     * @returns {boolean} 是否全部为中文
     */
    isChinese: function (s) {
      for (var index = 0, len = s.length; index < len; index++) {
        var charCode = s.charCodeAt(index);
        if ((charCode < 19968) || (charCode > 40869)) {
          return false;
        }
      }
      return true;
    }.bind(this),
    /**
     * 检查字符串是否含有中文
     * @param {string} s 字符串
     * @returns {boolean} 是否全部为中文
     */
    hasChineseChar: function (s) {
      var reg = /[\u4e00-\u9Fa5]/g;
      if (reg.test(s)) {
        return true;
      }
      return false;
    }.bind(this),
    /**
     * 检查字符串是否为合法的日期
     * @param {string} s 字符串
     * @param {boolean} 是否为合法日期
     *
     */
    isDate: function (s) {
      var flag = "";
      if (s.length == 8) {
        flag = this.$_format.parseDate(s, "yyyymmdd").format("yyyy-mm-dd");
      }
      return (this.$_format.REGEXP_ISDATE.test(flag));
    }.bind(this),
    /**
     * 检查字符串是否为合法的Email
     * @param {string} s 字符串
     * @returns {boolean} 是否为合法Email
     */
    isEmail: function (s) {
      if (s.length > 50) {
        return false;
      }
      return (this.$_format.REGEXP_EMAIL.test(s));
    }.bind(this),
    /**
     * 检查字符串是否为合法的身份证号码
     * @param {string} s 字符串
     * @returns {boolean} 是否为合法身份证号码
     */
    isIDNumber: function (s) {
      // 检查长度是否合法
      switch (s.length) {
        case 15:
        case 18: {
          break;
        }
        default: {
          return false;
        }
      }
      // 检查是否为数字
      var testInt = (s.length == 15) ? s : s.substr(0, 17);
      if (!this.$_format.isInteger(testInt)) {
        return false;
      }
      // 检查区域代码是否合法
      var areaCode = parseInt(s.substr(0, 2));
      if (!this.$_format.AREA_CODE[areaCode]) {
        return false;
      }
      // 检查出生日期是否合法
      var birthDay = (s.length == 15) ? ("19" + s.substr(6, 6)) : s.substr(6, 8);
      if (!this.$_format.isDate(birthDay)) {
        return false;
      }
      // 检查校验位是否合法
      if (s.length == 18) {
        var testNumber = (parseInt(s.charAt(0)) + parseInt(s.charAt(10))) * 7 +
          (parseInt(s.charAt(1)) + parseInt(s.charAt(11))) * 9 +
          (parseInt(s.charAt(2)) + parseInt(s.charAt(12))) * 10 +
          (parseInt(s.charAt(3)) + parseInt(s.charAt(13))) * 5 +
          (parseInt(s.charAt(4)) + parseInt(s.charAt(14))) * 8 +
          (parseInt(s.charAt(5)) + parseInt(s.charAt(15))) * 4 +
          (parseInt(s.charAt(6)) + parseInt(s.charAt(16))) * 2 +
          parseInt(s.charAt(7)) * 1 +
          parseInt(s.charAt(8)) * 6 +
          parseInt(s.charAt(9)) * 3;
        if (s.charAt(17) != "10X98765432".charAt(testNumber % 11)) {
          return false;
        }
      }
      return true;
    }.bind(this),

    /**
     * 检查字符串是否是纯数字和纯符号
     * @param {string} s 字符串
     * @returns {boolean} 是否纯数字和纯符号
     */
    isOnlyNumOrSymbol: function (s) {
      var flag = false;
      for (var index = 0, len = s.length; index < len; index++) {
        var charCode = s.charCodeAt(index);
        if (this.$_format.REGEXP_ONLYNUMORSYMBOL.test(s)) {
          flag = true;
          break;
        }
      }
      return flag;
    }.bind(this),
    parseDate: function (dateString, format) {
      var year = 2000,
        month = 0,
        day = 1,
        hour = 0,
        minute = 0,
        second = 0;
      format = format || this.$_format.DATE_FORMAT;
      var matchArray = format.match(this.$_format.REGEXP_DATE);
      for (var i = 0; i < matchArray.length; i++) {
        var postion = format.indexOf(matchArray[i]);
        switch (matchArray[i]) {
          case "yyyy": {
            year = parseInt(dateString.substr(postion, 4), 10);
            break;
          }
          case "mm": {
            month = parseInt(dateString.substr(postion, 2), 10) - 1;
            break;
          }
          case "dd": {
            day = parseInt(dateString.substr(postion, 2), 10);
            break;
          }
          case "hh": {
            hour = parseInt(dateString.substr(postion, 2), 10);
            break;
          }
          case "mi": {
            minute = parseInt(dateString.substr(postion, 2), 10);
            break;
          }
          case "ss": {
            second = parseInt(dateString.substr(postion, 2), 10);
            break;
          }
        }
      }
      return new Date(year, month, day, hour, minute, second);
    }.bind(this),
    // 将日期字符串 转换成 yyyy-mm-dd 格式
    formatDate: function (date, outFormat) {
      if (date == '' || date == null) {
        return '';
      } else {
        var parsedDate = this.$_format.parseDate(date, this.$_format.DATE_FORMAT);
        if (outFormat && typeof outFormat === "string") {
          return parsedDate.format(outFormat);
        } else {
          return parsedDate.format(this.$_format.DATE_FORMAT_SHORT);
        }
      }
    }.bind(this),
    // 将时间字符串 转换成 hh:mm:ss 格式
    formatTime: function (data, format) {
      var parsedDate = this.$_format.parseDate(data, this.$_format.TIME_FORMAT);
      if (format && typeof outFormat === "string") {
        return parsedDate.format(format);
      } else {
        return parsedDate.format(this.$_format.TIME_FORMAT_DISPLAY);
      }
    }.bind(this),

    formatTimeString: function (date) {
      if (!date) return
      const day = date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2)
      const sec = date.substr(8, 2) + ':' + date.substr(10, 2) + ':' + date.substr(12, 2)
      return day + ' ' + sec
    }.bind(this),
    
    formatDateTime: function (data, format) {
      var parsedDate = this.$_format.parseDate(data, this.$_format.DATETIME_FORMAT);
      if (format && typeof outFormat === "string") {
        return parsedDate.format(format);
      } else {
        return parsedDate.format(this.$_format.DATE_FORMAT_SHORT + " " + this.$_format.TIME_FORMAT_DISPLAY);
      }
    }.bind(this),
    getToday: function () {
      return store.state.app.timeInfo.date;
    }.bind(this),
    removeComma: function (str) {
      return str.replace(this.$_format.REGEXP_COMMA, '');
    }.bind(this),
    removeNegSign: function (str) {
      return str.replace(this.$_format.REGEXP_NEGSIGN, '');
    }.bind(this),
    addComma: function (str) {
      if (str.length > 3) {
        var mod = str.length % 3;
        var output = (mod > 0 ? (str.substring(0, mod)) : '');
        for (var i = 0; i < Math.floor(str.length / 3); i++) {
          if ((mod == 0) && (i == 0))
            output += str.substring(mod + 3 * i, mod + 3 * i + 3);
          else
            output += ',' + str.substring(mod + 3 * i, mod + 3 * i + 3);
        }
        return (output);
      } else
        return str;
    }.bind(this),

    prepareCashString: function (cash, dot, digits) {
      if (cash == undefined) cash = '0';
      if (dot == undefined) dot = true;
      if (digits == undefined) digits = 2;

      if (typeof cash !== 'string') {
        cash = cash.toString();
      }
      cash = this.$_format.removeComma(cash);

      //TODO检查是否金额
      // 处理包含正负符号的情况
      var prefix = cash.charAt(0);
      if (prefix == "-" || prefix == "+") {
        return prefix + this.$_format.prepareCashString(cash.substr(1), dot, digits);
      }

      if (cash.indexOf('.') != -1) {
        dot = true; //如果输入串本身包含小数点，则忽略dot参数的设置，认为是真实金额大小
      }
      var integerCash, decimalCash;
      if (!dot) {
        if (cash.length <= digits) {
          cash = cash.leftPadZero(digits + 1);
        }
        integerCash = cash.substring(0, cash.length - digits);
        decimalCash = cash.substring(cash.length - digits);
      } else {
        var dotPos = cash.indexOf('.');
        if (dotPos != -1) {
          integerCash = cash.substring(0, dotPos);
          decimalCash = cash.substring(dotPos + 1);
        } else {
          integerCash = cash;
          decimalCash = '';
        }
        if (integerCash.length == 0)
          integerCash = '0';
        if (decimalCash.length < digits) {
          decimalCash += '0'.times(digits - decimalCash.length);
        } else {
          decimalCash = decimalCash.substring(0, digits); // 考虑四舍五入
        }
      }

      //去掉头部多余的0
      while (integerCash.charAt(0) == '0' && integerCash.length > 1) {
        integerCash = integerCash.substring(1);
      }
      cash = integerCash + '.' + decimalCash;

      return cash;
    }.bind(this),

    prepareCashString_grb: function (cash, dot, digits) {
      if (cash == undefined) cash = '0';
      if (dot == undefined) dot = true;
      if (digits == undefined) digits = 0;

      if (typeof cash !== 'string') {
        cash = cash.toString();
      }
      cash = this.$_format.removeComma(cash);

      //TODO检查是否金额
      // 处理包含正负符号的情况
      var prefix = cash.charAt(0);
      if (prefix == "-" || prefix == "+") {
        return prefix + this.$_format.prepareCashString(cash.substr(1), dot, digits);
      }

      if (cash.indexOf('.') != -1) {
        dot = true; //如果输入串本身包含小数点，则忽略dot参数的设置，认为是真实金额大小
      }
      var integerCash, decimalCash;
      if (!dot) {
        if (cash.length <= digits) {
          cash = cash.leftPadZero(digits + 1);
        }
        integerCash = cash.substring(0, cash.length - digits);
        decimalCash = cash.substring(cash.length - digits);
      } else {
        var dotPos = cash.indexOf('.');
        if (dotPos != -1) {
          integerCash = cash.substring(0, dotPos);
          decimalCash = cash.substring(dotPos + 1);
        } else {
          integerCash = cash;
          decimalCash = '';
        }
        if (integerCash.length == 0)
          integerCash = '0';
        if (decimalCash.length < digits) {
          decimalCash += '0'.times(digits - decimalCash.length);
        } else {
          decimalCash = decimalCash.substring(0, digits); // 考虑四舍五入
        }
      }

      //去掉头部多余的0
      while (integerCash.charAt(0) == '0' && integerCash.length > 1) {
        integerCash = integerCash.substring(1);
      }
      cash = integerCash;

      return cash;
    }.bind(this),
    convertIntegerToChineseCash: function (cash) {
      if (cash == "0")
        return "";
      var S = ""; //返回值
      var p = 0; //字符位置index
      var m = cash.length % 4; //取模

      // 四位一组得到组数
      var k = (m > 0 ? Math.floor(cash.length / 4) + 1 : Math.floor(cash.length / 4));
      // 外层循环在所有组中循环
      // 从左到右 高位到低位 四位一组 逐组处理
      // 每组最后加上一个单位: "[万亿]","[亿]","[万]"
      for (var i = k; i > 0; i--) {
        var L = 4;
        if (i == k && m != 0) {
          L = m;
        }
        // 得到一组四位数 最高位组有可能不足四位
        var s = cash.substring(p, p + L);
        var l = s.length;

        // 内层循环在该组中的每一位数上循环 从左到右 高位到低位
        for (var j = 0; j < l; j++) {
          var n = parseInt(s.substring(j, j + 1));
          if (n == 0) {
            if ((j < l - 1) && (parseInt(s.substring(j + 1, j + 1 + 1)) > 0) //后一位(右低)
              &&
              S.substring(S.length - 1, S.length) != this.$_format.MONEY_NUMS[n]) {
              S += this.$_format.MONEY_NUMS[n];
            }
          } else {
            //处理 1013 一千零"十三",  1113一千一百"一十三"
            //                if (!(n == 1 && (S.substring(S.length-1,S.length) == this.$_format.MONEY_NUMS[0] | S.length == 0) && j == l - 2))
            //                {
            S += this.$_format.MONEY_NUMS[n];
            //                }
            S += this.$_format.MONEY_DIGITS[l - j - 1];
          }
        }
        p += L;
        // 每组最后加上一个单位: [万],[亿] 等
        if (i < k) {
          //不是最高位的一组
          if (s > 0) {
            //如果所有 4 位不全是 0 则加上单位 [万],[亿] 等
            S += this.$_format.MONEY_BIGUNITS[i - 1];
          }
        } else {
          //处理最高位的一组,最后必须加上单位
          S += this.$_format.MONEY_BIGUNITS[i - 1];
        }
      }
      return S + this.$_format.MONEY_SHOWNAME[2];
    }.bind(this),

    convertDecimalToChineseCash: function (cash) {
      var returnCash = "";
      if (cash == "00") {
        returnCash = this.$_format.MONEY_POSTFIX;
      } else {
        for (var i = 0; i < cash.length; i++) {
          if (i >= 2) {
            break;
          }
          var intValue = parseInt(cash.charAt(i));
          switch (i) {
            case 0:
              if (intValue != 0) {
                returnCash += this.$_format.MONEY_NUMS[intValue] + this.$_format.MONEY_SHOWNAME[1];
              }
              break;
            case 1:
              returnCash += this.$_format.MONEY_NUMS[intValue] + this.$_format.MONEY_SHOWNAME[0];
              break;
            default:
              break;
          }
        }
      }
      return returnCash;
    }.bind(this),

    toPercentRate: function (rate) {
      if (this.$_format.isEmpty(rate)) {
        return '';
      }
      if (parseFloat(rate) == 0) {
        return '';
      }
      var temp = parseFloat(rate);
      return temp * 100 + "%";
    }.bind(this),

    toChineseCash: function (cash) {
      if (this.$_format.isEmpty(cash) || !this.$_format.isMoney(cash)) {
        return '';
      }
      var noCommaCash = this.$_format.prepareCashString(cash);
      if (parseFloat(cash) == 0) {
        return '';
      }
      if (this.$_format.isInteger(noCommaCash)) {
        return this.$_format.convertIntegerToChineseCash(noCommaCash);
      }
      var dotIndex = noCommaCash.indexOf('.');
      var integerCash = noCommaCash.substring(0, dotIndex);
      var decimalCash = noCommaCash.substring(dotIndex + 1);
      var result = "";
      if (!this.$_format.isEmpty(integerCash)) {
        result += this.$_format.convertIntegerToChineseCash(integerCash);
      }
      if (!this.$_format.isEmpty(decimalCash)) {
        result += this.$_format.convertDecimalToChineseCash(decimalCash);
      }
      return result;
    }.bind(this),
    toCashWithComma: function (cash, dot, digits) {
      if (cash != null && typeof cash !== "string") {
        cash = cash.toString();
      }
      if (cash == '' || cash == null) {
        return '';
      } else {
        var temp = this.$_format.prepareCashString(cash, dot, digits);

        var dotPos = temp.indexOf('.');
        var integerCash = temp.substring(0, dotPos);
        var decimalCash = temp.substring(dotPos + 1);

        // 处理包含正负符号的情况
        var prefix = integerCash.charAt(0);
        if (prefix == "-" || prefix == "+") {
          temp = prefix + this.$_format.addComma(integerCash.substring(1)) + '.' + decimalCash;
        } else {
          temp = this.$_format.addComma(integerCash) + '.' + decimalCash;
        }
        if (temp == "0.00") {
          return '0.00';
        }
        return temp;
      }
    }.bind(this),
    // 转账功能  日元和韩元  币种精度显示 不同  by  zhangxin
    toCashWithComma_grb: function (cash, dot, digits) {
      if (cash != null && typeof cash !== "string") {
        cash = cash.toString();
      }
      if (cash == '' || cash == null) {
        return '';
      } else {
        var temp = this.$_format.prepareCashString(cash, dot, digits);

        var dotPos = temp.indexOf('.');
        var integerCash = temp.substring(0, dotPos);
        //	var decimalCash = temp.substring(dotPos + 1);

        //var cashTemp=Math.round(parseFloat(temp));
        //cashTemp = cashTemp.toString();

        // 处理包含正负符号的情况
        var prefix = integerCash.charAt(0);
        if (prefix == "-" || prefix == "+") {
          temp = prefix + this.$_format.addComma(integerCash.substring(1));
        } else {
          temp = this.$_format.addComma(integerCash);
        }
        if (temp == "0.00") {
          return '0';
        }
        return temp;
      }
    }.bind(this),

    formatAccountNo: function (accNo) {
      return accNo.substring(0, 4) + " **** " + accNo.substring(8, 12);
    }.bind(this),

    addNegSign: function (dateString) {
      if (this.$_format.isEmpty(dateString)) {
        return false;
      } else {
        return dateString.substr('0', '4') + '-' + dateString.substr('4', '2') + '-' + dateString.substr('6', '2');
      }

    }.bind(this),
    /**
     * 以月为单位获取日期,
     * @param {string} startDate指定日期，decMonth间隔月份。
     * @returns {string}
     * **/
    getLastMonth: function (startDate, decMonth) {
      var $startDate = startDate;
      if (this.$_format.isEmpty($startDate)) {
        $startDate = new Date(store.state.app.timeInfo.date.replace(/-/g, "/"));
      } else {
        if (startDate.length == 8) {
          $startDate = new Date(startDate.substr(0, 4) + '/' + startDate.substr(4, 2) + '/' + startDate.substr(6, 2));
        } else {
          $startDate = new Date(startDate.replace(/-/g, "/"));
        }
      }
      var decMon = parseInt(decMonth);
      var month = $startDate.getMonth() + 1;
      var day = $startDate.getDate();
      var year = $startDate.getFullYear();
      var monthHasDay = new Array([0], [31], [28], [31], [30], [31], [30], [31], [31], [30], [31], [30], [31]);
      while (decMon >= 12) {
        decMon -= 12;
        year -= 1;
      }
      if (month <= decMon) {
        year -= 1;
        month = 12 - (decMon - month);
      } else {
        month -= decMon;
      }
      if ((year % 4 == 0 && year % 100 != 0) || (year % 100 == 0 && year % 400 == 0)) {
        monthHasDay[2] = 29;
      }
      day = monthHasDay[month] >= day ? day : monthHasDay[month];
      var stringDate = year + '-' + (month < 10 ? "0" + month : month) + '-' + (day < 10 ? "0" + day : day);
      return stringDate;
    }.bind(this),
    formatDateTimeForChinese: function (data, format) {
      var parsedDate = this.$_format.parseDate(data, this.$_format.DATETIME_FORMAT);
      if (format && typeof outFormat === "string") {
        return parsedDate.format(format);
      } else {
        return parsedDate.format(this.$_format.DATE_FORMAT_DISPLAY + " " + this.$_format.TIME_FORMAT_DISPLAY);
      }
    }.bind(this),
    formatDateForChinese: function (data, format) {
      var parsedDate = this.$_format.parseDate(data, this.$_format.DATE_FORMAT);
      if (format && typeof outFormat === "string") {
        return parsedDate.format(format);
      } else {
        return parsedDate.format(this.$_format.DATE_FORMAT_DISPLAY);
      }
    }.bind(this),
    formatMonthForChinese: function (data, format) {
      var parsedDate = this.$_format.parseDate(data, this.$_format.MONTH_FORMAT);
      if (format && typeof outFormat === "string") {
        return parsedDate.format(format);
      } else {
        return parsedDate.format(this.$_format.MONTH_FORMAT_DISPLAY);
      }
    }.bind(this),

    dataToDate: function (value) {
      var flag = "";
      if (value != null && value != "") {

        flag = this.$_format.parseDate(value, "yyyymmddhhmiss").format("yyyy-mm-dd hh:mi:ss");
        /*if(value){
        	var yyyy = value.substring(0,4);
        	var mm = value.substring(4,6);
        	var dd = value.substring(6,8);
        	flag = yyyy+"-"+mm+"-"+dd;
        }*/
        /*else if(value.length==6){
        					var yyyy = value.substring(0,4);
        					var mm = value.substring(4,6);
        					flag = yyyy+"-"+mm;
        				}*/
      }
      return flag;
    }.bind(this),
    dataToDay: function (value) {
      var flag = "";
      if (value != null && value != "") {
        if (value.length == 8) {
          flag = this.$_format.parseDate(value, "yyyymmdd").format("yyyy-mm-dd");
        } else
          flag = this.$_format.parseDate(value, "yyyymmddhhmiss").format("yyyy-mm-dd");

        /*if(value){
        	var yyyy = value.substring(0,4);
        	var mm = value.substring(4,6);
        	var dd = value.substring(6,8);
        	flag = yyyy+"-"+mm+"-"+dd;
        }*/
        /*else if(value.length==6){
        					var yyyy = value.substring(0,4);
        					var mm = value.substring(4,6);
        					flag = yyyy+"-"+mm;
        				}*/
      }
      return flag;
    }.bind(this),
    /**
     * 以天为单位获取日期
     * @param {string} startDate指定日期，days间隔天数。
     * @returns {string}
     * **/
    getLastDay: function (startDate, days) {
      if (!(this.$_format.isEmpty(startDate))) {
        return this.$_format.formatDateToString((new Date(startDate.replace(/-/g, "/"))).prevDay(days));
      } else {
        return this.$_format.formatDateToString((new Date(store.state.app.timeInfo.date.replace(/-/g, "/"))).prevDay(days));
      }
    }.bind(this),
    formatDateToString: function (tDate) {
      var month = tDate.getMonth() + 1;
      var day = tDate.getDate();
      var year = tDate.getFullYear();
      var stringDate = year + '-' + (month < 10 ? "0" + month : month) + '-' + (day < 10 ? "0" + day : day);
      return stringDate;
    }.bind(this),
    /**
     * 以月为单位获取日期,
     * @param {string} startDate指定日期，decMonth间隔月份。
     * @returns {string}
     * **/
    getLastMonth: function (startDate, decMonth) {
      var $startDate = startDate;
      if (this.$_format.isEmpty($startDate)) {
        $startDate = new Date(store.state.app.timeInfo.date.replace(/-/g, "/"));
      } else {
        if (startDate.length == 8) {
          $startDate = new Date(startDate.substr(0, 4) + '/' + startDate.substr(4, 2) + '/' + startDate.substr(6, 2));
        } else {
          $startDate = new Date(startDate.replace(/-/g, "/"));
        }
      }
      var decMon = parseInt(decMonth);
      var month = $startDate.getMonth() + 1;
      var day = $startDate.getDate();
      var year = $startDate.getFullYear();
      var monthHasDay = new Array([0], [31], [28], [31], [30], [31], [30], [31], [31], [30], [31], [30], [31]);
      while (decMon >= 12) {
        decMon -= 12;
        year -= 1;
      }
      if (month <= decMon) {
        year -= 1;
        month = 12 - (decMon - month);
      } else {
        month -= decMon;
      }
      if ((year % 4 == 0 && year % 100 != 0) || (year % 100 == 0 && year % 400 == 0)) {
        monthHasDay[2] = 29;
      }
      day = monthHasDay[month] >= day ? day : monthHasDay[month];
      var stringDate = year + '-' + (month < 10 ? "0" + month : month) + '-' + (day < 10 ? "0" + day : day);
      return stringDate;
    }.bind(this),
    /**
     * 金额校验函数
     *
     * **/
    checkMoney: function (minAmt, maxAmt) {
      if (this.$_format.isEmpty(minAmt) || this.$_format.isEmpty(maxAmt))
        return true;
      if (parseFloat(minAmt) > parseFloat(maxAmt)) {
        return "开始金额不能大于截止金额！";
      } else {
        return true
      }
    }.bind(this),
    toUsedCashWithoutComma: function (cash) {
      return this.$_format.removeComma(this.$_format.toCashWithComma(cash));
    }.bind(this),
    /**
     * 日期校验函数
     *
     * **/
    checkDate: function (startDate, endDate, dur, minDate, maxDate) {
      if (this.$_format.isEmpty(startDate) && this.$_format.isEmpty(endDate))
        return true;

      var sDate
      var eDate

      //如果只传入开始日期则默认判断结束日期是否在minDate之前，minDate为空则默认为一年前的当天。
      if (!this.$_format.isEmpty(startDate)) {
        if (startDate.length == 8) {
          sDate = new Date(startDate.substr(0, 4) + '/' + startDate.substr(4, 2) + '/' + startDate.substr(6, 2))
        } else {
          sDate = new Date(startDate.replace(/-/g, "/"))
        }
        if (this.$_format.isEmpty(minDate)) {
        	if (!new Date(this.$_format.getLastMonth(store.state.app.timeInfo.date, '12').replace(/-/g, '/')).isBefore(sDate)) {
            return i18n.locale === 'zh-CN' ? ('开始日期必须在一年以内！') : ('The start date must be within one year!')
          }
        } else {
        	if (!new Date(minDate.replace(/-/g,   "/")).isBefore(sDate)) {
            return i18n.locale === 'zh-CN' ? ('开始日期不能早于' + minDate + '！') : ('The start date cannot be earlier than' + minDate + '！')
          }
        }
      }

      //如果只传入结束日期则默认判断结束日期是否在maxDate之前，maxDate为空则默认为当天。
      if (!this.$_format.isEmpty(endDate)) {
        if (endDate.length == 8) {
          eDate = new Date(endDate.substr(0, 4) + '/' + endDate.substr(4, 2) + '/' + endDate.substr(6, 2))
        } else {
          eDate = new Date(endDate.replace(/-/g, "/"))
        }
        if (this.$_format.isEmpty(maxDate)) {
        	if (eDate.isBefore(new Date(this.$_format.getLastMonth(store.state.app.timeInfo.date, '12').replace(/-/g, '/')))) {
            return i18n.locale === 'zh-CN' ? ('结束日期必须在一年以内！') : ('The end date must be within one year!')
          }
        	if (!eDate.isBefore(new Date(store.state.app.timeInfo.date.replace(/-/g, '/')))) {
            return i18n.locale === 'zh-CN' ? ('结束日期不能超过系统当前日期！') : ('The end date cannot later than the current system date!')
          }
        } else {
        	if (!eDate.isBefore(new Date(maxDate.replace(/-/g, '/')))) {
            return i18n.locale === 'zh-CN' ? ('结束日期不能超过'+ maxDate +'！') : ('The end date cannot be later than' + maxDate + '！')
          }
        }
      }

      if (!sDate.isBefore(eDate)) {
        return i18n.locale === 'zh-CN' ? ('开始日期不能大于结束日期！') : ('The start date cannot be later than the end date!')
      }
      var durMonth
      if (this.$_format.isEmpty(dur)) {
        durMonth = 3
      } else {
        durMonth = parseInt(dur)
      }
      var $endData = new Date(this.$_format.getLastMonth(endDate, durMonth).replace(/-/g, "/"))
      if (!$endData.isBefore(sDate)) {
        return i18n.locale === 'zh-CN' ? ('日期间隔不能超过' + durMonth + '个月') : ('The date interval cannot be more than' + durMonth + 'months')
      }
      return true
    }.bind(this),
    /**
     * 日期校验函数-果仁宝转账记录查询
     * author zhangxin
     * **/
    checkDateGRB: function (startDate, endDate, dur, minDate, maxDate) {
      if (this.$_format.isEmpty(startDate) && this.$_format.isEmpty(endDate))
        return true;

      var sDate;
      var eDate;

      //如果只传入开始日期则默认判断结束日期是否在minDate之前，minDate为空则默认为一年前的当天。
      if (!this.$_format.isEmpty(startDate)) {
        if (startDate.length == 8) {
          sDate = new Date(startDate.substr(0, 4) + '/' + startDate.substr(4, 2) + '/' + startDate.substr(6, 2));
        } else {
          sDate = new Date(startDate.replace(/-/g, "/"));
        }
        if (this.$_format.isEmpty(minDate)) {
        	if (!new Date(this.$_format.getLastMonth(store.state.app.timeInfo.date, '12').replace(/-/g, '/')).isBefore(sDate)) {
            return i18n.locale === 'zh-CN' ? ('开始日期必须在一年以内！') : ('The start date must be within one year!')
          }
        } else {
        	if (!new Date(minDate.replace(/-/g, '/')).isBefore(sDate)) {
            return i18n.locale === 'zh-CN' ? ('开始日期不能早于' + minDate + '！') : ('The start date cannot be earlier than' + minDate + '！')
          }
        }
      }

      //如果只传入结束日期则默认判断结束日期是否在maxDate之前，maxDate为空则默认为当天。
      if (!this.$_format.isEmpty(endDate)) {
        if (endDate.length == 8) {
          eDate = new Date(endDate.substr(0, 4) + '/' + endDate.substr(4, 2) + '/' + endDate.substr(6, 2));
        } else {
          eDate = new Date(endDate.replace(/-/g, "/"));
        }
        if (this.$_format.isEmpty(maxDate)) {
          if (!eDate.isBefore(new Date(store.state.app.timeInfo.date.replace(/-/g, "/"))))
            return i18n.locale === 'zh-CN' ? ('结束日期不能超过系统当前日期！') : ('The end date cannot later than the current system date!')
        } else {
          if (!eDate.isBefore(new Date(maxDate.replace(/-/g, "/"))))
            return i18n.locale === 'zh-CN' ? ('结束日期不能超过'+ maxDate +'！') : ('The end date cannot be later than' + maxDate + '！')
        }
      }
      if (!sDate.isBefore(eDate)) {
        return i18n.locale === 'zh-CN' ? ('开始日期不能大于结束日期！') : ('The start date cannot be later than the end date!')
      };
      var durMonth;
      if (this.$_format.isEmpty(dur)) {
        durMonth = 3;
      } else {
        durMonth = parseInt(dur);
      }
      var $endData = new Date(this.$_format.getLastMonth(endDate, durMonth).replace(/-/g, "/"));
      if (!$endData.isBefore(sDate)) {
        return i18n.locale === 'zh-CN' ? ('日期间隔不能超过' + durMonth + '个月') : ('The date interval cannot be more than' + durMonth + 'months')
      }
      return true;
    }.bind(this)
  }
}
